import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getVersionfeatures,
  versionfeaturesListSuccessful,
  versionfeaturesAddSuccessful,
  isModelVisible,
} from "./versionfeatures​Slice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* getVersionfeature({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/versionfeatures/", params);
    yield put(versionfeaturesListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddVersionfeatures({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/versionfeatures/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Version Feature Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getVersionfeatures({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Version Feature. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(versionfeaturesAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/versionfeatures/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Version Feature Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getVersionfeatures({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Version Feature. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(versionfeaturesAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteVersionfeatures({ payload }) {
  var countryID = payload;
  try {
    const response = yield call(postDelete, "/masters/versionfeatures/" + countryID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Version Feature has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getVersionfeatures({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Unable to Delete Version Feature. Please try again!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchgetVersionfeatures() {
  yield takeEvery("versionfeatures/getVersionfeatures", getVersionfeature);
}
export function* watchVersionfeaturesAdd() {
  yield takeEvery("versionfeatures/versionfeaturesAdd", AddVersionfeatures);
}

export function* watchVersionfeaturesDelete() {
  yield takeEvery("versionfeatures/versionfeaturesDelete", DeleteVersionfeatures);
}

function* VersionfeaturesSaga() {
  yield all([fork(watchgetVersionfeatures), fork(watchVersionfeaturesAdd), fork(watchVersionfeaturesDelete)]);
}

export default VersionfeaturesSaga;
